import { render } from "./LoadingScreen.vue?vue&type=template&id=5a1b3ec2&scoped=true&ts=true"
import script from "./LoadingScreen.vue?vue&type=script&lang=ts"
export * from "./LoadingScreen.vue?vue&type=script&lang=ts"

import "./LoadingScreen.vue?vue&type=style&index=0&id=5a1b3ec2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1b3ec2"]])

export default __exports__